// Fills the form with the home page banner data
export const fillForm = (items) => {
  return {
    Image: null,
    Id: items?.id,
    Url: items?.url,
    Title: items?.title,
    Subtitle: items?.subtitle,
    IsActive: items?.isActive,
    ImageFullUrl: items?.imageFullUrl,
  };
};
